// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1fIAl","topBottomGutter":"Layout_topBottomGutter__1Obic"};